/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFalling = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10.084 3h2v3.387l7.852 6.193V17h-2v-3.45l-1.19-.939-4.917 6.236V22h-2v-3.847l1.013-1.284-1.978-1.56-2.395.154-1.733 3.033L3 17.504l2.267-3.967 3.275-.21 3.493-4.431-1.951-1.539zm3.522 7.135L10.51 14.06l1.57 1.238 3.096-3.926z" />
        <path d="M15.75 4.185A3 3 0 1 1 20.462 7.9a3 3 0 0 1-4.711-3.715zm2.975 1.072a1 1 0 1 0-1.238 1.57 1 1 0 0 0 1.238-1.57z" />
      </g>
    </g>
  </Icon>
);
export { SvgFalling as Falling };
